import { createFileRoute } from "@tanstack/react-router";

import { PlatformHead, PlatformPage } from "@/features/platform/components/platform-chrome";
import { PlatformClosing } from "@/features/platform/modules/closing/platform-closing";
import { ForWhomDays, ForWhomHero } from "@/features/platform/modules/for-whom-page/for-whom-page";
import { TeamSize } from "@/features/platform/modules/team/team-size";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/who-its-for/")({
  head: () => ({
    meta: pageMeta({ title: m.seo_for_whom_title(), description: m.seo_for_whom_description() }),
  }),
  loader: () => ({ crumb: m.platform_nav_for_whom() }),
  component: ForWhomPage,
});

/** Who the coach app is for: trainers, studios, dieticians and physios, each on their own day in it. */
function ForWhomPage() {
  return (
    <PlatformPage
      head={
        <PlatformHead>
          <ForWhomHero />
        </PlatformHead>
      }
    >
      <ForWhomDays />
      <TeamSize />
      <PlatformClosing />
    </PlatformPage>
  );
}
